import { Alert } from '@c1/gravity-react';
import { FunctionComponentProps, FunctionComponentReturnType } from "src/types/sharedReact";
import 'src/components/AlertBanner/AlertBanner.css';
import clsx from 'clsx';
import { isMobile } from 'react-device-detect';
import React, { useEffect, useState, useCallback, forwardRef, useImperativeHandle } from 'react';
import { GetBannerResponse } from 'src/types/apiResponse';
import { AxiosError } from 'axios';
import RouteBuilder from 'src/utils/routing/RouteBuilder';
import { useRouteBuilder } from 'src/utils/routing/RouteBuilderContext';
import { getFromApi } from 'src/utils/getFromApi';
import 'src/components/BannerUtility/BannerUtility.css'
import { Banner } from 'src/types/banner';
import { BannerType } from 'src/types/bannerType';

const BannerUtility =  forwardRef((props, ref )=> {
    const [banners, setBanners] = useState<Banner[]>([]);

    useImperativeHandle(ref,
        () => ({
            addBanner: (banner: Banner)=>{
                setBanners(prev => [...prev, banner]);
            },
            removeBanner: (banner: Banner)=>{
                setBanners(prev => prev.filter(b => b !== banner ))
            },
            removeBannerById: (bannerId: string)=>{
                setBanners(prev => prev.filter(banner => banner.bannerId !== bannerId ))
            }
        }),
        [banners, setBanners]
    );

    let handleClose = useCallback((bannerToRemove: Banner)=>{
        try {
            bannerToRemove?.callback?.(bannerToRemove)
        } catch(e) {}
        setBanners(prev => prev.filter(banner => banner !== bannerToRemove ))
    }, [banners]);




    return (<div className="banner-alert-container">
        {banners?.length > 0 ? banners?.map((banner) => (<Alert
            type={banner?.bannerType}
            active={banner?.isActive}
            message={banner?.bannerMessage}
            onAction={ ()=>{ handleClose(banner) }}
            className={"banner-alert"}
            actionText={banner?.actionText || "X"}
        />)): null}
        </div>)
})

export default BannerUtility;
